import React from 'react';
import FaceScanScreen from '../screens/FaceScanScreen';

export default function NewAnalysisPage(): React.JSX.Element {
  return <FaceScanScreen mode="page" />;
}
